import DownhillSkiingIcon from "@mui/icons-material/DownhillSkiing";

const ChaletLoader = () => {
  return (
    <div className="chalet-loader">
      <div className="ski-icon-wrapper">
        <DownhillSkiingIcon className="ski-icon" />
      </div>
      <p className="loader-text">Finding your perfect chalet...</p>
    </div>
  );
};

export default ChaletLoader;
